import React from "react";
import BookmarkDisplayCard from "components/bookmark/bookmark-displaycard";

const BookmartCardRenderer = ({ items }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4 py-6 px-1.5">
      {items.map((item) => {
        const latestLinks = item.bookmark_folder.links
          .sort((a, b) => b.date_created - a.date_created)
          .slice(0, 5);

        return (
          <div key={item.id}>
            <BookmarkDisplayCard
              projectId={item.project_id}
              projectLogo={item.logo}
              projectTitle={item.name}
              bookmarkCount={item.bookmark_folder.links.length}
              links={latestLinks}
            />
          </div>
        );
      })}
    </div>
  );
};

export default BookmartCardRenderer;
